import React from 'react';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import { useTheme } from '@mui/material/styles';

const SkillChips: React.FC<{ skills: string[]; size?: 'small' | 'medium' }> = ({ skills, size = 'small' }) => {
    const dark = useTheme().palette.mode === 'dark';
    return (
        <Stack direction="row" flexWrap="wrap" gap={0.75}>
            {skills.map(s => (
                <Chip key={s} label={s} size={size} sx={{ fontFamily: "'JetBrains Mono', monospace", fontSize: size === 'small' ? '0.7rem' : '0.8rem', fontWeight: 500, bgcolor: dark ? 'rgba(96,165,250,0.1)' : 'rgba(37,99,235,0.06)', color: dark ? '#93C5FD' : '#2563EB', border: 'none' }} />
            ))}
        </Stack>
    );
};

export default SkillChips;
